import $i18n from '@alife/panda-i18n';
export const componentName = 'BusValueAddedService';
export const PayMethods = [
    { label: $i18n.get({ id: 'PresentSettlement', dm: '现结' }), value: 1 },
    { label: $i18n.get({ id: 'MonthlySettlement', dm: '月结' }), value: 2 },
];
export const affirmInfoList = [
    {
        label: $i18n.get({ id: 'SettlementCustomer', dm: '结算客户' }),
        key: 'selfVasPayerInfo',
        validateKey: '',
    },
    {
        label: $i18n.get({ id: 'SettlementMethod', dm: '结算方式' }),
        key: 'selfVasAccountTypeDesc',
        validateKey: '',
    },
    {
        label: $i18n.get({ id: 'TotalQuantityPieces', dm: '总数量(件)' }),
        key: 'selfVasNum',
        validateKey: 'cnSelfVasNum',
    },
    {
        label: $i18n.get({ id: 'TotalVolumeM', dm: '总体积(立方米)' }),
        key: 'selfVasVolume',
        validateKey: 'cnSelfVasVolume',
    },
    {
        label: $i18n.get({ id: 'TotalWeightKg', dm: '总重量(千克)' }),
        key: 'selfVasWeight',
        validateKey: 'cnSelfVasWeight',
    },
    // {
    //   label: '应收总金额',
    //   key: 'selfVasAmount',
    //   color: 'red',
    // },
];
// 1  创建
// 2, "已受理"
// 3, "待支付"
// 4, "已支付"
// 5, "月结"
// -1, "取消"
export const PayStatusList = [
    // { value: '-1', color: '#4393cc', font: '#333333' },
    { value: '1', color: '#80BFFF', font: '#333333' },
    { value: '2', color: '#0080FF', font: '#333333' },
    { value: '3', color: '#FFD500', font: '#80760D' },
    { value: '4', color: '#14CC70', font: '#333333' },
    { value: '-1', color: '#C3D4E6', font: '#333333' },
    { value: '5', color: '#143666', font: '#333333' },
];
// 增值服务 - 操作项控制
// showItem: ['count', 'weight', 'volume'],
// requiredItem: ['count', 'weight', 'volume'],
export const serviceList = [
    {
        value: '1',
        label: $i18n.get({
            id: 'SelfoperatedloadingAndUnloading',
            dm: '自营-装卸',
        }),
        showItem: 'weight, volume',
        requiredItem: 'weight, volume',
    },
    {
        value: '2',
        label: $i18n.get({ id: 'SelfemployedsingleSticker', dm: '自营-单贴' }),
        showItem: 'count',
        requiredItem: '',
    },
    {
        value: '3',
        label: $i18n.get({ id: 'SelfemployedPost', dm: '自营-打加贴' }),
        showItem: 'count',
        requiredItem: '',
    },
    {
        value: '4',
        label: $i18n.get({
            id: 'ProprietaryPostCodeInLibrary',
            dm: '自营-库内贴码',
        }),
        showItem: 'weight,volume',
        requiredItem: '',
    },
];
export const sourceHeaders = [
    {
        enable: true,
        key: 'selfVasTypeDesc',
        name: $i18n.get({ id: 'ServiceItem', dm: '服务项' }),
        width: 80,
    },
    {
        enable: true,
        key: 'selfVasNum',
        name: $i18n.get({ id: 'TotalQuantityPieces', dm: '总数量(件)' }),
        width: 80,
    },
    {
        enable: true,
        key: 'selfVasVolume',
        name: $i18n.get({ id: 'TotalVolumeM', dm: '总体积(立方米)' }),
        width: 100,
    },
    {
        enable: true,
        key: 'selfVasWeight',
        name: $i18n.get({ id: 'TotalWeightKg', dm: '总重量(千克)' }),
        width: 100,
    },
    {
        enable: true,
        key: 'selfVasAmount',
        name: $i18n.get({ id: 'AmountReceivable', dm: '应收金额' }),
        width: 80,
    },
    {
        enable: true,
        key: 'selfVasPayStatusDesc',
        name: $i18n.get({ id: 'PaymentStatus', dm: '支付状态' }),
        width: 80,
    },
    {
        enable: true,
        key: 'selfVasPaySerialNo',
        name: $i18n.get({ id: 'FundNumber', dm: '资金单号' }),
        width: 80,
    },
    {
        enable: true,
        key: 'selfVasLbzCode',
        name: $i18n.get({ id: 'ValueAddedServiceNumber', dm: '增值服务单号' }),
        width: 100,
    },
];
